module.exports = __webpack_public_path__ + "static/media/sls.310efb69.svg";